import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services';
import ChangePasswordModal from './modals/ChangePasswordModal';
import ChangeTPinModal from './modals/ChangeTPinModal';
import RightBar from './RightBar';
import Lottie from 'lottie-react';

const Header = ({ onToggleSidebar, sidebarCollapsed, sidebarVisible, onLogout }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  // const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showSettingsBar, setShowSettingsBar] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showChangeTPinModal, setShowChangeTPinModal] = useState(false);
  const [walletAnimationData, setWalletAnimationData] = useState(null);
  const [wallets] = useState([
    { label: 'Balance', amount: '₹25,000' },
    { label: 'Payin', amount: '₹15,000' }
  ]);
  const navigate = useNavigate();
  // const notificationRef = useRef(null);
  const profileRef = useRef(null);

  // Get user role from localStorage
  useEffect(() => {
    const role = authService.getUserRole();
    setUserRole(role || 'User');

    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Sample notification data
  const notifications = [
    { id: 1, title: 'New user registered', message: 'John Doe has created an account', time: '2 min ago', unread: true },
    { id: 2, title: 'Payment received', message: 'Payment of $150 from client ABC', time: '1 hour ago', unread: true },
    { id: 3, title: 'System update', message: 'System maintenance completed', time: '3 hours ago', unread: false },
    { id: 4, title: 'New message', message: 'You have a new message from support', time: '1 day ago', unread: false },
  ];

  // Load wallet animation data
  useEffect(() => {
    fetch('/FlyingWalletMoney.json')
      .then(response => response.json())
      .then(data => setWalletAnimationData(data))
      .catch(error => console.error('Error loading wallet animation:', error));
  }, []);

  // Handle click outside to close dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      // if (notificationRef.current && !notificationRef.current.contains(event.target)) {
      //   setShowNotifications(false);
      // }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getToggleIcon = () => {
    if (isMobile) {
      return sidebarVisible ? 'bi-x-lg' : 'bi-list';
    }
    return sidebarCollapsed ? 'bi-list' : 'bi-chevron-left';
  };

  // const toggleNotifications = () => {
  //   setShowNotifications(!showNotifications);
  //   setShowProfileMenu(false); // Close profile menu when opening notifications
  // };

  const toggleProfileMenu = () => {
    setShowProfileMenu(!showProfileMenu);
    // setShowNotifications(false); // Close notifications when opening profile menu
  };

  const handleNavigateToProfile = () => {
    setShowProfileMenu(false);
    navigate('/profile');
  };

  const handleProfileLinkClick = (e) => {
    e.preventDefault();
    handleNavigateToProfile();
  };

  const handleAvatarClick = (e) => {
    e.stopPropagation();
    handleNavigateToProfile();
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    setShowProfileMenu(false);
    setShowChangePasswordModal(true);
  };

  const handleChangeTPin = (e) => {
    e.preventDefault();
    setShowProfileMenu(false);
    setShowChangeTPinModal(true);
  };

  const toggleSettingsBar = () => {
    setShowSettingsBar(!showSettingsBar);
    setShowProfileMenu(false);
  };

  return (
    <header className={`fintech-header ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <div className="header-menu">
        <i 
          className={`bi ${getToggleIcon()} fs-responsive-md`}
          style={{ cursor: 'pointer' }}
          onClick={onToggleSidebar}
        ></i>
      </div>
      
      <div className="header-actions">
        {['retailer', 'super_distributor', 'master_distributor', 'distributor', 'api_partner'].includes(
          userRole
        ) && (
          <div className="wallet-summary d-none d-lg-flex" style={{ gap: '0.75rem' }}>
            {wallets.map((wallet, index) => (
              <div
                className="balance-container"
                key={wallet.label}
                style={{ marginLeft: index === 0 ? 0 : '0.5rem' }}
              >
                <div className="balance-content">
                  <div className="balance-info">
                    <div className="balance-icon">
                      {walletAnimationData ? (
                        <Lottie
                          animationData={walletAnimationData}
                          loop
                          autoplay
                          style={{ width: 38, height: 38 }}
                        />
                      ) : (
                        <i className="bi bi-wallet2"></i>
                      )}
                    </div>
                    <div className="balance-text">
                      <div className="balance-label">{wallet.label}</div>
                      <div className="balance-amount">{wallet.amount}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Notifications */}
        {/* <div className="notification-container" ref={notificationRef}>
          <div className="notification-icon" onClick={toggleNotifications}>
            <i className="bi bi-bell fs-responsive-md"></i>
            <span className="notification-badge fs-responsive-xs">
              {notifications.filter(n => n.unread).length}
            </span>
          </div>
          
          {showNotifications && (
            <div className="notification-dropdown">
              <div className="dropdown-header">
                <h6>Notifications</h6>
                <span className="notification-count">
                  {notifications.filter(n => n.unread).length} new
                </span>
              </div>
              <div className="notification-list">
                {notifications.map((notification) => (
                  <div 
                    key={notification.id} 
                    className={`notification-item ${notification.unread ? 'unread' : ''}`}
                  >
                    <div className="notification-content">
                      <div className="notification-title">{notification.title}</div>
                      <div className="notification-message">{notification.message}</div>
                      <div className="notification-time">{notification.time}</div>
                    </div>
                    {notification.unread && <div className="unread-indicator"></div>}
                  </div>
                ))}
              </div>
              <div className="dropdown-footer">
                <a href="#" className="view-all-link">View all notifications</a>
              </div>
            </div>
          )}
        </div> */}

        {/* Profile Menu */}
        <div className="profile-container" ref={profileRef}>
          <div className="user-profile" onClick={toggleProfileMenu}>
            <div className="user-avatar" onClick={handleAvatarClick}>
              <i className="bi bi-person-circle fs-responsive-lg"></i>
            </div>
            <div className="user-info d-none d-md-block" onClick={handleAvatarClick}>
              <div className="user-name">{userRole}</div>
              <div className="user-role">{userRole}</div>
            </div>
            <i className="bi bi-chevron-down profile-chevron d-none d-md-block"></i>
          </div>
          
          {showProfileMenu && (
            <div className="profile-dropdown">
              <div className="dropdown-header">
                <div className="profile-avatar">
                  <i className="bi bi-person-circle"></i>
                </div>
                <div className="profile-details">
                  <div className="profile-name">{userRole}</div>
                  <div className="profile-email">{userRole.toLowerCase().replace(' ', '')}@Shakti E Solution.com</div>
                </div>
              </div>
              <div className="profile-menu-list">
                <a href="#" className="profile-menu-item" onClick={handleProfileLinkClick}>
                  <i className="bi bi-person-badge-fill"></i>
                  <span>My Profile</span>
                </a>
                <a href="#" className="profile-menu-item" onClick={handleChangePassword}>
                  <i className="bi bi-lock-fill"></i>
                  <span>Change Password</span>
                </a>
                <a href="#" className="profile-menu-item" onClick={handleChangeTPin}>
                  <i className="bi bi-shield-lock-fill"></i>
                  <span>Change T-PIN</span>
                </a>
                <hr className="dropdown-divider" />
                <button onClick={handleLogout} className="profile-menu-item logout">
                  <i className="bi bi-box-arrow-right"></i>
                  <span>Sign Out</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Change Password Modal */}
      <ChangePasswordModal 
        show={showChangePasswordModal} 
        handleClose={() => setShowChangePasswordModal(false)} 
      />

      {/* Change T-PIN Modal */}
      <ChangeTPinModal 
        show={showChangeTPinModal} 
        handleClose={() => setShowChangeTPinModal(false)} 
      />
    </header>
  );
};

export default Header;
